import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

// Typewriter that types its segments when scrolled into view.
// segments: [{ text: string, className?: string }]
export function Typewriter({ segments, speed = 32, startDelay = 200, cursor = true, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const full = segments.reduce((acc, s) => acc + s.text, "");
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let i = 0;
    let timer;
    const tick = () => {
      i += 1;
      setCount(i);
      if (i < full.length) timer = setTimeout(tick, speed);
    };
    timer = setTimeout(tick, startDelay);
    return () => clearTimeout(timer);
  }, [inView, full, speed, startDelay]);

  const done = count >= full.length;
  let remaining = count;

  return (
    <span ref={ref} className={className} aria-label={full}>
      {segments.map((s, idx) => {
        const take = Math.max(0, Math.min(s.text.length, remaining));
        remaining -= s.text.length;
        return (
          <span key={idx} className={s.className}>
            {s.text.slice(0, take)}
          </span>
        );
      })}
      {cursor && !done && (
        <span className="inline-block w-[3px] h-[0.95em] -mb-[0.1em] ml-1 bg-brand-orange align-middle animate-pulse" />
      )}
    </span>
  );
}

export default Typewriter;
